module.exports = __webpack_public_path__ + "static/media/external-machine-02.bc3e5b93.png";